export default {
  domainWebSite: null,
  domainWebSiteCn: null,
  contactEmail: null,
  accountEmail: null,
}
